module.exports = __webpack_public_path__ + "static/media/wheelIcon.b78af61f.png";